<template>
  <b-modal
    id="ModalNewReward"
    size="md"
    centered
    :hide-header="true"
    :hide-footer="true"
    content-class="p-2 atm-rounded"
  >
    <h3 class="mb-3 font-weight-bold">{{ title }}</h3>
    <div class="px-3">
      <div class="mb-4">
        <slot></slot>
      </div>
      <div
        class="d-flex flex-column gap-4 justify-content-center align-items-center "
      >
        <button
          v-for="(button, idx) in buttonOptions"
          :key="idx"
          class="atm-button flex-grow-1 bg-main font-weight-bold w-100"
          @click="button.action"
        >
          {{ button.text }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    title: { type: String, default: '' },
    buttonOptions: {
      type: Array,
      default: () => [
        { text: 'Button', action: () => {} },
      ]
    }
  },
};
</script>

